import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
const QuarryPage = () => {
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/k278pUNBYob384y3LzFCt9/Madeleine_Morlet_1.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/quJDNDLwFr6ZpXctYCCKKG/Madeleine_Morlet_2.jpg', 'TEXT_BLOCK', 'https://uploadthingy.s3.us-west-1.amazonaws.com/u9BKR4eWkBQweagZty9T8C/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5HdUXpAEnygFvnprkeJjaA/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4C2Au3sSLogDPKFbABUuzt/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tGg9DY3PyoU3fTPvhitQ1u/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4KTzqv6r3EJjjjapBGoaHG/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/boZWPYM2G9DDbXLfDmcTGd/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tEAvFDRevS83oNpKLXTxib/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/bWmYuX3nGrXyGY5ndqUGkF/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/cvtieYqZkVTXJC9aXMwnLU/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/h8JtKF1eWwK71tK5pPheFn/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/xaPcAab7oVGJSrqsh4cR5X/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/n5n38K26gBLkyX8zv4SbTi/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ob43ZJF4dwxhyFjku8Xnsw/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wV7hQMsDfQEDbHSyvDPuiG/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9B2RoA9imXALxwJABwqaeY/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/c6484uPeHNFWLQ9XoVpS7N/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/sYHYdihEQWiHhb9FiXk4jk/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/s5gEUd4qarznVJ8BQNhKhD/Madeleine_Morlet_20.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mZacCaDf9fq23DF4FmcMuo/Madeleine_Morlet_21.jpg'];
  const getSpacing = index => {
    // Special case for text block transitions
    if (index === 1) return 2; // Reduced spacing before text block
    if (index === 2) return 2; // Reduced spacing after text block
    const spacings = [8, 14, 10, 16, 12, 18, 9, 15];
    return spacings[index % spacings.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh'; // First image consistent
    if (index === 1) return '85vh'; // Make second actual image larger
    const sizes = ['80vh', '65vh', '75vh', '70vh', '85vh'];
    return sizes[index % sizes.length];
  };
  // Text block content for both desktop and mobile
  const textBlockContent = <div className="italic leading-relaxed" data-id="element-508" data-mp="168p1r0h03i2m">
      <p className="pl-4" data-id="element-509" data-mp="128y4qf0vs5pn">
        Years before Georgia went missing, they'd had their first drinks
        together. It was Georgia who had pulled a bottle–a glass globe with real
        flakes of gold drifting in cinnamon liquor–out of her bag at the dock.
        They sat and sipped and tossed stones into the black water, voices
        whisked away by wind coming in off the waves. They were best friends.
      </p>
      <p className="pl-4 indent-8" data-id="element-510" data-mp="ikfctpohqe79">
        Clare knew where all of Georgia's scars were–a dog bite on her ankle,
        and a burn on her inner arm–and Georgia knew hers–a small slice on her
        lip from a knife she'd licked. Clare could tell the difference between
        different kinds of sleepiness in Georgia's voice, one when she first
        woke up in the morning and one late at night, when she was almost
        asleep. She could picture the way Georgia's hair swirled at her temples
        and the loops of her fingerprints.
      </p>
      <p className="pl-4 indent-8" data-id="element-511" data-mp="24nfipc0hvd2l">
        Clare and Georgia met in fifth grade and grew close over the twisted
        knot of emotions they shared about their parents. Georgia had been
        adopted by a single woman who did so out of a Christian sense of
        righteousness rather than love or even interest. This led Bernice,
        Georgia's adoptive mother, to expect gratitude from Georgia, like she
        had done her a holy favor for which Georgia was forever in her debt.
        Clare's own mother had been the stable one of her two parents and, when
        she died three years before, Clare was left with a booze-soaked
        fisherman father who had started dating younger women months after the
        funeral.
      </p>
      <p className="pl-4 indent-8" data-id="element-512" data-mp="31ehft7qhw1xx">
        Georgia's dark humor helped Clare. And Clare was a good listener for
        Georgia. Clare let Georgia rant because, for Georgia, anger was the main
        ingredient churning in her stomach. For Clare, it was cold sadness.
      </p>
      <p className="pl-4 indent-8" data-id="element-513" data-mp="prnlzg7cd8a8">
        When they were eighteen, years after the night they swallowed the gold
        flakes, both Clare and Georgia got the fat college acceptance letters in
        their mailboxes but none from the same schools. Clare went away to hers
        and Georgia went to another. All year they talked, Georgia yelling into
        the phone from a party, Clare turning down the volume at the library.
      </p>
      <p className="pl-4 indent-8" data-id="element-514" data-mp="19goetfhca26v">
        Georgia's first summer break began just one week before Clare's but
        Georgia dreaded that week, she said. Georgia would be back in their
        hometown by herself.
      </p>
    </div>;
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-515" data-mp="3p6sp92k3snfg">
      <Header data-id="element-516" data-mp="3k6wl93beovzw" />
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-517" data-mp="3k87nuzt47xpf">
        <div className="flex min-w-max" data-id="element-518" data-mp="1o4jq70ppwhh7">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '20vh' // Reduced from 24vh to 20vh
        }} data-id="element-519" data-mp="1o5l031uzyxxc">
            <div className="text-base max-w-[360px] pr-4" data-id="element-520" data-mp="1x2n4bbydibyz">
              <div className="mb-6" data-id="element-521" data-mp="223jg0boyv2ey">The Quarry (Self-published, 2022)</div>
              <div className="text-sm leading-relaxed" data-id="element-522" data-mp="272dvp4rn0auu">
                <p data-id="element-523" data-mp="271uoahzm54v2">Digital Broadsheet</p>
                <p data-id="element-524" data-mp="2c1h2atn9mp4x">20 pages/ 16 Images</p>
                <p data-id="element-525" data-mp="2c0fhhxgg6oa0">350mm x 500mm</p>
                <p data-id="element-526" data-mp="2bzco9ivnk9qx">
                  Short Story by{' '}
                  <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-527" data-mp="2gt8kafscvmjg">
                    Vivian Ewing
                  </a>
                </p>
                <p data-id="element-528" data-mp="2ux65m2l9i0sf">First Edition of 300 (Numbered & Signed)</p>
                <p data-id="element-529" data-mp="2uziwj58zzlhm">
                  <a href="https://www.paypal.com/ncp/payment/Z5FJB4YYKMNFW" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#2563eb';
                }} data-id="element-530" data-mp="2qwdu12ox3jsz">
                    PURCHASE HERE.
                  </a>
                </p>
                <p className="mt-6" data-id="element-531" data-mp="5gic0uf7xoyl">
                  This is the story of two best friends, fresh out of their
                  first year at college, returning home to their small town in
                  coastal Maine. The photographs illustrate the landscape and
                  community of young adults who live there.
                </p>
                <p className="mt-6" data-id="element-532" data-mp="f4ia3x87vhu3">
                  Review:{' '}
                  <a href="https://blog.photoeye.com/2022/08/book-of-week-selected-by-odette-england.html" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-533" data-mp="k6h8stt0hqkp">
                    Book of the Week: Selected by Odette England
                  </a>
                </p>
                <p data-id="element-534" data-mp="25o9xydl0sii2">Stock list: Photo-Eye Bookstore SOLD OUT</p>
                <p className="mt-6 text-xs italic" data-id="element-535" data-mp="25qw366kfulx4">
                  Funded in part by a grant from the Maine Arts Commission; an
                  independent state agency supported by the National Endowment
                  for the Arts.
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-536" data-mp="2am1lkvemtigg">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-537" data-mp="1hx48r7t6wdv3" data-mpi={index}>
                {image === 'TEXT_BLOCK' ? <div className="w-[800px] mx-auto px-4" style={{
              height: '70vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }} data-id="element-538" data-mp="137ybhpdwwxpu">
                    <div className="text-[#333333]" data-id="element-539" data-mp="3u8bsugtx4fsz">{textBlockContent}</div>
                  </div> : <img src={image} alt={`The Quarry - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-540" data-mp="3pcwgjtbk6ryo" />}
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-541" data-mp="36ihji98t59dh">
        <div className="mb-6" data-id="element-542" data-mp="31k67psyycosm">
          <div className="text-base mb-4" data-id="element-543" data-mp="31kfy3hnwsxyu">
            The Quarry (Self-published, 2022)
          </div>
          <div className="text-sm leading-relaxed mb-6" data-id="element-544" data-mp="2wo7pyo84q516">
            <p data-id="element-545" data-mp="1c4vlzzftge4k">Digital Broadsheet</p>
            <p data-id="element-546" data-mp="1c3u9dqj5jjkq">20 pages/ 16 Images</p>
            <p data-id="element-547" data-mp="1h2x2ccluxzcc">350mm x 500mm</p>
            <p data-id="element-548" data-mp="1h23zvntxlw00">
              Short Story by{' '}
              <a href="https://www.vivianewing.com/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-549" data-mp="1m2a03se9oqtp">
                Vivian Ewing
              </a>
            </p>
            <p data-id="element-550" data-mp="tbhvq7n1svva">First Edition of 300 (Numbered & Signed)</p>
            <p data-id="element-551" data-mp="ydqs7dz4qg25">
              <a href="https://www.paypal.com/ncp/payment/Z5FJB4YYKMNFW" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" data-id="element-552" data-mp="yd78brpx5hlh">
                PURCHASE HERE.
              </a>
            </p>
            <p className="mt-4" data-id="element-553" data-mp="al0h16z1w0sx">
              This is the story of two best friends, fresh out of their first
              year at college, returning home to their small town in coastal
              Maine. The photographs illustrate the landscape and community of
              young adults who live there.
            </p>
            <p className="mt-4" data-id="element-554" data-mp="1rp5kaywux06w">
              Review:{' '}
              <a href="https://blog.photoeye.com/2022/08/book-of-week-selected-by-odette-england.html" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-555" data-mp="1rom0fcnnc1q8">
                Book of the Week: Selected by Odette England
              </a>
            </p>
            <p data-id="element-556" data-mp="181ocf3jgn5id">Stock list: Photo-Eye Bookstore SOLD OUT</p>
            <p className="mt-4 text-xs italic" data-id="element-557" data-mp="17z3damajr3ob">
              Funded in part by a grant from the Maine Arts Commission; an
              independent state agency supported by the National Endowment for
              the Arts.
            </p>
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-558" data-mp="2feq5zpkeabjv">
          {images.map((image, index) => {
          if (image === 'TEXT_BLOCK') {
            return <div key={index} className="w-full text-sm mb-8" data-id="element-559" data-mp="2ry52qms51al7">
                  {textBlockContent}
                </div>;
          }
          return <div key={index} className="w-full" data-id="element-560" data-mp="2hzfsng6hgufi" data-mpi={index}>
                <img src={image} alt={`The Quarry - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-561" data-mp="2i07dbvyjl7r0" />
              </div>;
        })}
        </div>
      </div>
      <ScrollIndicator data-id="element-562" data-mp="2vzgsqtexbxtx" />
      <style jsx data-id="element-563" data-mp="2vzyx6dbqpicx">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default QuarryPage;